import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import {
  getWorkshopsSuccess,
  getWorkshopsFailure,
  getSingleWorkshopsSuccess,
  getSingleWorkshopsFailure,
} from "../slice/workshopSlice";
const url = process.env.REACT_APP_API_URL;
// const url =" http://localhost:6002"

// function* getSingleWorkshopsRequest(action) {
//   try {
//     const response = yield call(() =>
//       axios.get(`${url}/courseDetails?courseId=${action.payload}`)
//     );
//     yield put(getSingleCoursesSuccess(response.data.data));
//   } catch (error) {
//     yield put(getSingleCoursesFailure(error.message));
//   }
// }

function* getWorkshopsRequest(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${url}/getAllWorkshop?page=${action.payload.page}&limit&sort=${action.payload.sort}&search=${action.payload.search}`
      )
    );
    yield put(getWorkshopsSuccess(response.data.data));
  } catch (error) {
    yield put(getWorkshopsFailure(error.message));
  }
}

// export function* watchGetSingleWorkshops() {
//   yield takeLatest("workshop/getSingleWorkshops", getSingleWorkshopsRequest);
// }
export function* watchGetWorkshops() {
  yield takeLatest("workshop/getWorkshops", getWorkshopsRequest);
}
